import React, { useState } from "react";
import { useMutation } from "react-apollo";
import { toast } from "react-toastify";
import { CleanMessage } from "../../../../util/app";
import { UPDATE_HISTORY } from "../../../../queries/patient.query";
import LoadingSpinner from "../../../../partials/loading";
import Editor from "../../../../partials/Editor";
import AsHtml from "../../../../partials/AsHtml";
import { EventEmitter } from "../../../../event/EventEmitter";
import { EVENT_TARGET, ACTION_TYPE } from "../../../../event/model";
import { sendNotification } from "../../../../sockette";

const PatientHistory = ({ item, id, isAdmin }) => {
    const [_history, setHistory] = useState(item);
    const [update, setUpdate] = useState(false);
    const [updateFunc, { loading }] = useMutation(UPDATE_HISTORY, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            if (d.UpdatePatientHistory) {
                const { doc, message } = d.UpdatePatientHistory;
                toast.success(message);
                sendNotification(doc, ACTION_TYPE.UPDATE, EVENT_TARGET.PATIENT);
                setUpdate(false);
            }
        },
    });

    EventEmitter.subscribe(EVENT_TARGET.History, (event) => setHistory(event));

    return (
        <div className="card">
            <div className="card-head">
                <header>Patient History</header>
            </div>
            <div className="card-body min-card">
                <LoadingSpinner loading={loading} bar={true} />
                <div className="row">
                    {!update && <div className="col-12 fade-in">{(_history && <AsHtml content={_history} />) || "No History available! "}</div>}

                    {update && (
                        <div className="col-12 fade-in">
                            <form
                                onSubmit={async (evt) => {
                                    evt.preventDefault();
                                    if (_history && id) {
                                        await updateFunc({
                                            variables: { id, history: _history },
                                        });
                                    } else {
                                        toast.warn("Invalid patient history!");
                                    }
                                }}
                            >
                                <div className="form-group">
                                    <label htmlFor="history-id">Patient History</label>
                                    <Editor content={_history} onChange={(_his) => setHistory(_his)} />
                                </div>
                                <div className="form-group text-right fade-in">
                                    <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect margin-right-10 btn-circle btn-success">
                                        Save <i className="material-icons">add</i>
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setUpdate(false);
                                            setHistory(item);
                                        }}
                                        className="mdl-button mdl-button--raised mdl-js-ripple-effect btn-circle"
                                    >
                                        Cancel <i className="material-icons text-danger">close</i>
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}
                </div>
            </div>
            {isAdmin && !update && (
                <div className="card-footer text-right fade-in">
                    <button onClick={() => setUpdate(true)} className="mdl-button mdl-js-button mdl-button--fab fab-mini">
                        <i className="material-icons text-success">edit</i>
                    </button>
                </div>
            )}
        </div>
    );
};

export default PatientHistory;
